<template>
  <div>
    <!-- HEADER -->
    <form-header :show-save-edit="false" :show-toolbox="false" >

<!--      &lt;!&ndash; Left side button - primary actions &ndash;&gt;-->
<!--      <template v-slot:primaryButton>-->
<!--        <slot name="primaryButton"></slot>-->
<!--      </template>-->

<!--      &lt;!&ndash; toolbars &ndash;&gt;-->
<!--      <template v-slot:toolButtons>-->
<!--        <headers-button-group>-->
<!--          <slot name="toolButtons"></slot>-->
<!--        </headers-button-group>-->
<!--      </template>-->

<!--      &lt;!&ndash; danger actions on the right &ndash;&gt;-->
<!--      <template v-slot:dangerButton>-->
<!--        <slot name="dangerButton"></slot>-->
<!--      </template>-->

      <template v-slot:additionalHeaderRows>
        <slot name="additionalHeaderRows"></slot>
      </template>

    </form-header>
    <!-- HEADER END-->


    <v-box ref="vbox" :scrollable="true">
      <!-- CONTENT -->
        <slot>
          <b-container>
            <b-row ref="items" class="mt-1">

            </b-row>
          </b-container>
        </slot>
      <!-- CONTENT END-->
    </v-box>

    <slot name="bottomLine"></slot>
    <!-- FOOTER -->
    <footer-navbar >
      <close-button @close="close"></close-button>
      <slot name="footer"></slot>
    </footer-navbar>
    <!-- FOOTER END -->
  </div>
</template>

<script>
import FormHeader from "@/components/forms/FormHeader";
import HeadersButtonGroup from "@/components/layout/HeaderButtonsGroup";
import FooterButton from "@/components/navbar/FooterButton";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import VBox from "@/components/VBox";
import CloseButton from "@/components/navbar/CloseButton";
import Rpc from "@/Rpc";
import Dashlets from "@/components/dashlets";
import Vue from "vue";
import Activity from "@/activity/Activity";
export default {
  name: "DashletsSelect",
  components: {CloseButton, VBox, FooterNavbar, FooterButton, HeadersButtonGroup, FormHeader},

  async mounted(){

    this.allDashletConfigs = await Rpc.Dashboards.getAvailableDashlets();
    this.allDashletConfigsByName = {};
    for(let dc of this.allDashletConfigs){
      this.allDashletConfigsByName[dc.name] = dc;
    }

    this.dashletsRenderersByName = {};
    for(let dashlet of Dashlets){
      if(!this.allDashletConfigsByName.hasOwnProperty(dashlet.name)){
        console.log(`${dashlet.name} not found on the server end`)
        continue;
      }

      let opt = {...dashlet, router: this.$router};
      let ComponentClass = Vue.extend(opt);
      this.dashletsRenderersByName[dashlet.name] = ComponentClass;
    }

    for(let dashletName in this.dashletsRenderersByName){
      let rendererClass = this.dashletsRenderersByName[dashletName];
      let dashletConf =  this.allDashletConfigsByName[dashletName];
      this.addDashletCard(dashletName, rendererClass, dashletConf);
    }
  },


  created() {

  },
  props: {

  },
  methods: {
    ... Activity.methods,
    /**
     * @param dashletName {String}
     * @param rendererClass
     * @param dashletConf {DashletConfig}
     */
    addDashletCard(dashletName, rendererClass, dashletConf){
      let colDiv = document.createElement("div");
      colDiv.setAttribute("class", "mb-1 col col-12 col-md-6 col-lg-4");

      let cardDiv = document.createElement("div");
      cardDiv.setAttribute("class", "card");
      colDiv.appendChild(cardDiv);

      let headDiv = document.createElement("div");
      headDiv.setAttribute("class", "card-header");
      headDiv.textContent = dashletConf.title;
      cardDiv.appendChild(headDiv);

      let bodyDiv = document.createElement("div");
      bodyDiv.setAttribute("class", "card-body");
      cardDiv.appendChild(bodyDiv);

      let bodyP = document.createElement("p");
      bodyP.innerHTML = dashletConf.description;
      bodyDiv.appendChild(bodyP);

      let addButton = document.createElement("button");
      addButton.setAttribute('class', 'btn btn-secondary');
      addButton.innerText = "Add to Dashboard";

      addButton.addEventListener('click', ()=>{
        this.closeAndAdd(dashletName);
      });

      bodyDiv.appendChild(addButton);
      this.$refs.items.appendChild(colDiv);

    },
    closeAndAdd(closeAndAdd){
      this.setResult(closeAndAdd);
      this.close();
    },
    isLayout(){
      return true;
    },

    getTitle(){
      return $tr('selectDashlet','Select Dashlet')
    },

  },
}
</script>

<style scoped>

</style>